module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// /home/gitlab_ci_multi_runner/builds/88e00e75/0/bryx911/ua-download/~/core-js/library/modules/$.add-to-unscopables.js
// module id = 449
// module chunks = 0